"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryString = _interopRequireDefault(require("query-string"));
var _config = _interopRequireDefault(require("../../../consts/config"));
var _headers = require("../../../services/fetch/headers");
const createSimpleToken = _ref => {
  let {
    email,
    origin,
    bookingId
  } = _ref;
  const queryParams = {
    email,
    src: origin.iataCode,
    dtime: origin.dateOfDeparture
  };
  const query = _queryString.default.stringify(queryParams);
  return fetch(`${_config.default.apiBookingUrl}/api/v0.1/users/get_simple_token/${bookingId}?${query}`, {
    method: "GET",
    headers: (0, _headers.getBasicHeaders)()
  }).then(response => response.json()).then(json => {
    if (json.status === "success") {
      return {
        token: json.simple_token
      };
    }
    return {
      error: json.msg === "Booking not found" ? "NOT_FOUND" : "UNKNOWN",
      message: json.msg
    };
  });
};
var _default = exports.default = createSimpleToken;